/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import axios from "axios";
import { api } from "@/services/api";
import { getToken } from "@/services/auth";
import ModalPopup from "@/components/ModalPopup";
import ShimmerEffect from "@/components/Shimmer";
import ButtonSwitch from "@/components/ButtonSwitch";

import { IconIonicIosClose, IconAwesomeCheck } from "@/Icons/img";

import { Container } from "./styles";

export const PDVCupons = () => {
	const [toogle, setToogle] = useState(false);
	const [data, setData] = useState(null);
	const [dataCuponsValidated, setDataCuponsValidated] = useState(0);
	const [dataCuponsRefund, setDataCuponsRefund] = useState(0);
	const [moreData, setMoreData] = useState(0);
	const [loadData, setLoadData] = useState(false);
	// const [ consumer, setComsumer ] = useState( "" )
	const [month, setMonth] = useState("");
	const [year, setYear] = useState("");

	const [modalPopup, setModalPopup] = useState(false);
	const [modalContent, setModalContent] = useState({
		title: "",
		content: "",
	});

	const [loading, setLoading] = useState(false);
	const loadElements = [];

	for (let index = 0; index < 12; index++) {
		loadElements.push(index);
	}

	useEffect(() => {
		const CancelToken = axios.CancelToken; // instância do CancelToken
		const source = CancelToken.source(); // instância do source, onde está contido o token de cancelamento

		const loadData = () => {
			setLoading(true);

			api.get("merchant/coupons", {
				cancelToken: source.token,
				params: {
					type: "list",
					page: 1,
				},
				headers: {
					Authorization: `Bearer ${getToken()}`,
				},
			})
				.then((res) => {
					setData(res?.data?.coupons);
					setDataCuponsValidated(res?.data?.total_validated);
					setDataCuponsRefund(res?.data?.total_refund);
					if (res.data.pages_info === "Há mais Cupons") {
						setMoreData(1);
					}
				})
				.catch((error) => {
					console.error({ endPoint: "merchant/coupons", error });
				})
				.finally(() => {
					setLoading(false);
				});
		};

		loadData();

		// retorna uma função com a finalidade fazer o cancelamento
		return () => {
			source.cancel();
		};
	}, []);

	function handleCupons() {
		const CancelToken = axios.CancelToken; // instância do CancelToken
		const source = CancelToken.source(); // instância do source, onde está contido o token de cancelamento

		setLoadData(true);

		const loadData = () => {
			api.get("merchant/coupons", {
				cancelToken: source.token,
				params: {
					type: "list",
					page: moreData + 1,
				},
				headers: {
					Authorization: `Bearer ${getToken()}`,
				},
			})
				.then((res) => {
					const newData = data;
					newData.push(...res.data.coupons);

					setData(newData);

					if (res.data.pages_info === "Há mais Cupons") {
						setMoreData(moreData + 1);
					} else {
						setMoreData(0);
					}

					setLoadData(false);
				})
				.catch((error) => {
					console.error({ endPoint: "merchant/coupons", error });
					setLoadData(false);
				});
		};

		loadData();

		// retorna uma função com a finalidade fazer o cancelamento
		return () => {
			source.cancel();
		};
	}

	function hadleToogle() {
		setToogle(!toogle);
	}

	function handleMonth(e, data) {
		const target = e.currentTarget.getAttribute("data-target");
		const button = document.querySelector(`[data-target='${target}']`);
		const allButton = document.querySelectorAll(
			`.months__list > [data-target]`,
		);

		if (allButton) {
			allButton.forEach((e) => e.classList.remove("active"));
		}

		if (button) {
			button.classList.add("active");
		}

		setMonth(data);

		// let arrayMonths = month
		// if( month.includes( data ) ) {
		//     arrayMonths = arrayMonths.filter( (_, index) => index !== arrayMonths.indexOf( data )  )
		// } else {
		//     arrayMonths.push( data )
		// }

		// setMonth( [ ...arrayMonths ] )
	}

	function handleYear(e, data) {
		const target = e.currentTarget.getAttribute("data-target");
		const button = document.querySelector(`[data-target='${target}']`);
		const allButton = document.querySelectorAll(
			`.years__list > [data-target]`,
		);

		if (allButton) {
			allButton.forEach((e) => e.classList.remove("active"));
		}

		if (button) {
			button.classList.toggle("active");
		}

		setYear(data);

		// let arrayYears = year
		// if( year.includes( data ) ) {
		//     arrayYears = arrayYears.filter( (_, index) => index !== arrayYears.indexOf( data )  )
		// } else {
		//     arrayYears.push( data )
		// }
		// setYear( [ ...arrayYears ] )
	}

	function handleFilters() {
		const CancelToken = axios.CancelToken; // instância do CancelToken
		const source = CancelToken.source(); // instância do source, onde está contido o token de cancelamento

		setLoadData(true);
		hadleToogle();

		const loadData = () => {
			api.get("merchant/coupons", {
				cancelToken: source.token,
				params: {
					type: "list",
					page: 1,
					filter: {
						// consumer,
						month,
						year,
					},
				},
				headers: {
					Authorization: `Bearer ${getToken()}`,
				},
			})
				.then((res) => {
					const newData = data;
					newData.push(...res.data.coupons);

					setData(newData);

					if (res.data.pages_info === "Há mais Cupons") {
						setMoreData(moreData + 1);
					} else {
						setMoreData(0);
					}

					setLoadData(false);
				})
				.catch((error) => {
					console.error({ endPoint: "merchant/coupons", error });
					setLoadData(false);
				});
		};

		loadData();

		// retorna uma função com a finalidade fazer o cancelamento
		return () => {
			source.cancel();
		};
	}

	function handleCoupon(id) {
		setModalPopup(true);
		setModalContent({
			title: "Programa Fidelidade GERIOOX",
			content: "Ressarcindo cupom, por favor aguarde...",
		});

		api.post(
			"merchant/coupons/refund",
			{
				coupon_id: id,
			},
			{
				headers: {
					Authorization: `Bearer ${getToken()}`,
				},
			},
		)
			.then((res) => {
				if (res.data.status === 200) {
					setModalPopup(true);
					setModalContent({
						title: "Programa Fidelidade GERIOOX",
						content: res.data.message,
					});

					let arrayData = data;
					let index = data.map((e) => e.id).indexOf(id);
					arrayData[index].situation = true;

					setData(arrayData);
				}

				if (res.data.status === 400) {
					setModalPopup(true);
					setModalContent({
						title: "Programa Fidelidade GERIOOX",
						content: res.data.message,
					});
				}
			})
			.catch((error) => {
				console.error({ endPoint: "/merchant/coupons/refund", error });
				setModalPopup(true);
				setModalContent({
					title: "Programa Fidelidade GERIOOX",
					content: "Ocorreu um problema tente novamente mais tarde",
				});
			});
	}

	return (
		<>
			<ModalPopup
				visible={modalPopup}
				message={modalContent}
				onClick={() => setModalPopup(!modalPopup)}
			/>
			<Container>
				<header className='header'>
					<h2>
						HISTÓRICO DE CUPONS VALIDADOS <button>?</button>
						{/* ATENCAO texto do button com "?" esta sendo adicionado via style */}
						<br />
						validados: {dataCuponsValidated} | Ressarcidos:{" "}
						{dataCuponsRefund}
					</h2>
					{/* <button onClick={hadleToogle}>Filtrar</button> */}
					<div className='legend'>
						<div>
							<IconIonicIosClose /> - cupom não ressarcido{" "}
							<button>?</button>
						</div>
						<div>
							<IconAwesomeCheck /> - cupom ressarcido.{" "}
							<button>?</button>
						</div>
					</div>
				</header>

				{data ? (
					<ul className='cupons'>
						{data?.map((cupom, index) => (
							<li key={index}>
								<header>
									<p className='cupomSerie'>
										<strong>Cupom N: </strong>
										{cupom?.code}
									</p>
									<p className='cupomDate'>
										<strong>
											{cupom?.validated_in
												?.split("-")
												?.reverse()
												?.join("/")}
										</strong>
									</p>
								</header>
								<div className='cupomInfo'>
									<div className='persona'>
										<p className='name'>
											{cupom?.consumer}
										</p>
										<p className='desc'>
											Utilizado 30% desconto
										</p>
									</div>
									{/* <div className='action'>
										{cupom?.situation ? (
											<IconAwesomeCheck />
										) : (
											<button
												onClick={() =>
													handleCoupon(cupom.id)
												}>
												<IconIonicIosClose />
											</button>
										)}
									</div> */}
									<ButtonSwitch
										id={cupom.id}
										sitiation={cupom?.situation}
										onClick={handleCoupon}
									/>
								</div>
							</li>
						))}
					</ul>
				) : (
					<ul className='cupons'>
						{loading &&
							loadElements.map((_, index) => (
								<li key={index}>
									<header>
										<div
											style={{ margin: "2px 0" }}
											className='cupomSerie'>
											<ShimmerEffect
												width={185}
												height={20}
											/>
										</div>
										<div
											style={{ margin: "2px 0" }}
											className='cupomDate'>
											<ShimmerEffect
												width={85}
												height={20}
											/>
										</div>
									</header>
									<div className='cupomInfo'>
										<div className='animal'>
											<div
												style={{ margin: "4px 0" }}
												className='name'>
												<ShimmerEffect
													width={150}
													height={20}
												/>
											</div>
											<div
												style={{ margin: "4px 0" }}
												className='status'>
												<ShimmerEffect
													width={150}
													height={20}
												/>
											</div>
										</div>
									</div>
								</li>
							))}
					</ul>
				)}

				<button
					className='load-data'
					onClick={handleCupons}
					style={{ display: moreData ? "block" : "none" }}>
					{loadData ? "Carregado..." : "Carregar mais dados"}
				</button>

				<div
					className='modal'
					style={{ display: `${toogle ? "block" : "none"}` }}>
					<div className='content'>
						<img
							loading='lazy'
							className='close'
							onClick={hadleToogle}
							src={
								require("@/assets/img/Icon ionic-ios-close.png")
									.default
							}
							alt='icone close'
						/>

						{/* <div className="form">
                        <h2>Filtrar por nome do cliente</h2>
                        <input type="text" placeholder="Insira o nome do cliente" />
                    </div> */}

						<div className='months'>
							<h2>Filtrar por nome do cliente</h2>
							<div className='months__list'>
								<button
									data-target='Janeiro'
									onClick={(e) => handleMonth(e, "Janeiro")}>
									Janeiro
								</button>
								<button
									data-target='Fevereiro'
									onClick={(e) =>
										handleMonth(e, "Fevereiro")
									}>
									Fevereiro
								</button>
								<button
									data-target='Março'
									onClick={(e) => handleMonth(e, "Março")}>
									Março
								</button>
								<button
									data-target='Abril'
									onClick={(e) => handleMonth(e, "Abril")}>
									Abril
								</button>
								<button
									data-target='Maio'
									onClick={(e) => handleMonth(e, "Maio")}>
									Maio
								</button>
								<button
									data-target='Junho'
									onClick={(e) => handleMonth(e, "Junho")}>
									Junho
								</button>
								<button
									data-target='Julho'
									onClick={(e) => handleMonth(e, "Julho")}>
									Julho
								</button>
								<button
									data-target='Agosto'
									onClick={(e) => handleMonth(e, "Agosto")}>
									Agosto
								</button>
								<button
									data-target='Setembro'
									onClick={(e) => handleMonth(e, "Setembro")}>
									Setembro
								</button>
								<button
									data-target='Outubro'
									onClick={(e) => handleMonth(e, "Outubro")}>
									Outubro
								</button>
								<button
									data-target='Novembro'
									onClick={(e) => handleMonth(e, "Novembro")}>
									Novembro
								</button>
								<button
									data-target='Dezembro'
									onClick={(e) => handleMonth(e, "Dezembro")}>
									Dezembro
								</button>
							</div>
						</div>

						<div className='years'>
							<h2>Filtrar por ano</h2>
							<div className='years__list'>
								<button
									data-target='2019'
									onClick={(e) => handleYear(e, "2019")}>
									2019
								</button>
								<button
									data-target='2020'
									onClick={(e) => handleYear(e, "2020")}>
									2020
								</button>
							</div>
						</div>

						<button
							onClick={handleFilters}
							className='btn-secundary'>
							Aplicar filtro
						</button>

						<button className='clear'>Limpar filtro</button>
					</div>
				</div>
			</Container>
		</>
	);
};

export default PDVCupons;
